// bao migrate skip
import "./../../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ConfigurationItem300HardwareTabDialog {
    Bao = Bao;
    Dialog: BaoDialog;
    ConfigurationItemTypeItem = ko.observable<any>();
    ManufacturerItem = ko.observable<any>();
    PurchaseVendorItem = ko.observable<any>();
    ManufacturerTypeItem = ko.observable<any>();
    ConfigurationItemTypeName = ko.observable();
    ConfigurationItemTypeId = ko.observable();
    ManufacturerId = ko.observable();
    ManufacturerName = ko.observable();
    ManufacturerTypeId = ko.observable();
    ManufacturerTypeName = ko.observable();
    PurchaseVendorId = ko.observable();
    PurchaseVendorName = ko.observable();
    WarrantyTypeId = ko.observable();
    WarrantyTypeName = ko.observable();
    Price = ko.observable<number>();
    Sort = ko.observable();
    Amount = ko.observable<number>();
    Sum = ko.observable();
    Name1 = ko.observable();
    Name2 = ko.observable();
    Number = ko.observable();
    OrderDate = ko.observable();
    DeliveryDate = ko.observable();
    //TODO:
    ManufacturerTypeEnabled = ko.observable<boolean>(true);
    ManufacturerEnabled = ko.observable<boolean>(true);
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        //this.ConfigurationItemTypeItem.subscribe((item) => {
        //    if (item != null) {
        //        this.ManufacturerTypeEnabled(true);
        //        this.ManufacturerEnabled(true);
        //    }
        //});
        this.ConfigurationItemTypeId.subscribe((item) => {
            //reset fields:
            this.ManufacturerId(null);
            this.ManufacturerName("");
            //if (item != null) {
            //    this.ManufacturerEnabled(true);
            //}
            //else {
            //    this.ManufacturerEnabled(false);
            //}
        });
        this.ManufacturerId.subscribe((item) => {
            //reset fields:
            this.ManufacturerTypeId(null);
            this.ManufacturerTypeName("");
            this.PurchaseVendorId(null);
            this.PurchaseVendorName("");
            //if (item != null) {
            //    this.ManufacturerTypeEnabled(true);
            //}
            //else {
            //    this.ManufacturerTypeEnabled(false);
            //}
        });
        this.ManufacturerTypeItem.subscribe((item) => {
            //set all Fields
            this.ItemChanged();
        });
        this.PurchaseVendorItem.subscribe((item) => {
            //set all Fields
            this.ItemChanged();
        });
        this.Amount.subscribe((value) => {
            this.Sum(this.Amount() * this.Price());
        });
    }
    ItemChanged() {
        return Bao.post("ConfigurationItem300HardwareTab/GetFieldData", JSON.stringify({
            manufacturerTypeId: this.ManufacturerTypeId(),
            purchaseVendorId: this.PurchaseVendorId()
        })).done(result => {
            if (result.Model != null) {
                //ko.map.fromJS(result.Model, this);
                this.Number(result.Model.Number);
                this.WarrantyTypeId(result.Model.WarrantyTypeId);
                this.WarrantyTypeName(result.Model.WarrantyTypeName);
                this.Name1(result.Model.Name1);
                this.Name2(result.Model.Name2);
                this.Price(result.Model.Price);
                this.Sum(null);
                this.Amount(null);
            }
        });
    }
    loaded() {
    }
}
export default ConfigurationItem300HardwareTabDialog;